export default __webpack_public_path__ + "static/media/ag-img.ceb531f1.webp";